import featureClient1 from "../clients/buko/feature.json";
import featureClient2 from "../clients/happytrails/feature.json";
import { appConfig } from "./app.config";

export const appFeatureRecord = {
  ["buko"]: featureClient1,
  ["happytrails"]: featureClient2,
};
export const appFeature =
  appFeatureRecord[appConfig.client as keyof typeof appFeatureRecord];
